import { useCallback } from 'react';

import { logError } from '@/shared/lib/logging';

type UseCopyToClipboard = (text: string, onCopy?: () => void) => () => void;

export const useCopyToClipboard: UseCopyToClipboard = (text, onCopy) =>
    useCallback(() => {
        if (!navigator.clipboard) {
            logError('Clipboard API not available');

            return;
        }

        navigator.clipboard
            .writeText(text)
            .then(onCopy)
            .catch((error) => logError('Failed to copy text:', error));
    }, [text, onCopy]);
